/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */
// Copyright (c) 2023 Deere & Company

import DuplicatePinPlateResult from './duplicate-pin-plate-result';
import DuplicatePinPlateView from '../state/duplicate-pin-plate-view';
import { FormattedMessage } from 'react-intl';
import ListViewShowMore from '../../../sharedmodules/components/list-view-show-more';
import PropTypes from 'prop-types';
import React from 'react';

const DuplicatePinPlateList = (props) => {

    let list;

    if (props.duplicatePinPlateChanges[0].pin !== '') {

        const duplicatePinPlates = props.duplicatePinPlateChanges.map((duplicatePlate, index) => (
            <DuplicatePinPlateResult
                actions={props.actions}
                auth={props.auth}
                duplicatePlate={duplicatePlate}
                key={index}
            />
        ));

        list = (
            <ListViewShowMore
                initialShowItems={50}
                perMoreMultiplier={1.25}
                showAllOption
                showPerMore={50}
                totalItems={props.duplicatePinPlateChanges.length}
            >
                {duplicatePinPlates}
            </ListViewShowMore>
        );

    } else {

        list = <span className="empty"><FormattedMessage id="NO_RESULTS_FOUND" /></span>;

    }

    return (
        <div className="product-list">
            <div className="list-header">
                {props.children}
            </div>
            {list}
        </div>
    );

};

DuplicatePinPlateList.displayName = 'DuplicatePinPlateList';
DuplicatePinPlateList.propTypes = {
    actions: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    children: PropTypes.node,
    duplicatePinPlateChanges: PropTypes.arrayOf(PropTypes.instanceOf(DuplicatePinPlateView)).isRequired,
};

export default DuplicatePinPlateList;
